/**
 * * (!기간제) 일반 판매 재화 테이블
 */

import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IDetail } from 'utils/types/saleTypes';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import CheckboxOneType from 'components/input/CheckboxOneType';
import CircleButton from 'components/button/CircleButton';
import InputTitle from 'components/etc/InputTitle';
import { useTranslation } from 'react-i18next';
import { IItem } from '../../../utils/types/storyTypes';
import DefaultButton from '../../../components/button/DefaultButton';
import { message } from 'antd';
import { ICoupon, ICouponReward } from '../../../utils/types/operationTypes';

interface IProps {
  items: IItem[];
  coupon: ICoupon;
  setCoupon: Dispatch<SetStateAction<ICoupon>>;
}

const CouponItemTable: React.FC<IProps> = ({ items, coupon, setCoupon }) => {
  const { t } = useTranslation();

  const handleSelectChange = (e, data) => {
    const { id, key, name, value } = data;

    for (const reward of coupon.rewards) {
      if (reward.item_id === value) {
        message.error('이미 추가된 아이템입니다.');
        return;
      }
    }

    const newRewards: ICouponReward[] = coupon.rewards.map((v) =>
      v.item_id === Number(id) ? { ...v, item_id: value } : v,
    );

    setCoupon({ ...coupon, rewards: newRewards });
  };

  const handleInputChange = (e, selectedItem?: IDetail) => {
    const { id, value } = e.target;

    const newRewards: ICouponReward[] = coupon.rewards.map((v) =>
      v.item_id === Number(id) ? { ...v, quantity: Number(value) } : v,
    );

    setCoupon({ ...coupon, rewards: newRewards });
  };

  const handlePlusClick = () => {
    setCoupon({
      ...coupon,
      rewards: [...coupon.rewards, { item_id: 0, quantity: 0 }],
    });
  };

  const handleMinusClick = (e) => {
    const selectedItem = coupon.rewards?.filter(
      (v) => v.item_id !== Number(e.target.value),
    );

    setCoupon({ ...coupon, rewards: selectedItem });
  };

  const allItems = items?.map((v) => ({
    key: v.id,
    text: `(${v.id}) ${v.origin_name}`,
    value: v.id,
  }));

  const canAdd = true;

  return (
    <Container>
      <div className='flex_wrap title_flex_wrap'>
        <InputTitle
          style={{ width: '15rem', textAlign: 'center', marginLeft: '0rem' }}
        >
          {'아이템'}
        </InputTitle>
        <InputTitle
          style={{ width: '6rem', textAlign: 'center', marginLeft: '0.5rem' }}
        >
          {'개수'}
        </InputTitle>
        {canAdd && (
          <DefaultButton onClick={handlePlusClick}>추가</DefaultButton>
        )}
      </div>

      {coupon.rewards.map((v, i) => (
        <div className='flex_wrap content_wrap'>
          <div style={{ marginRight: '0.5rem', paddingTop: '1rem' }}>
            <p>{i + 1}. </p>
          </div>
          <DefaultSelect
            name='item_id'
            id={`${v.item_id}`}
            value={v.item_id}
            optionList={allItems}
            onChange={(e, data) => handleSelectChange(e, data)}
            showSearch
            style={{ width: '15rem', marginRight: '1rem' }}
          />
          <div className='input_wrap'>
            <DefaultInput
              name='quantity'
              id={`${v.item_id}`}
              value={v.quantity}
              onChange={handleInputChange}
              type='number'
            />
          </div>
          <div style={{ paddingTop: '0.5rem' }}>
            <CircleButton
              name='subtract'
              value={`${v.item_id}`}
              onClick={handleMinusClick}
            >
              -
            </CircleButton>
          </div>
        </div>
      ))}
    </Container>
  );
};

export default CouponItemTable;

const Container = styled.div`
  width: 100%;
  margin-top: 0.8rem;

  .flex_wrap {
    //margin-bottom: 0.5rem;
    display: flex;
    //align-items: center;
    justify-content: flex-start;
  }

  .title_flex_wrap {
    margin-bottom: 0.3rem;

    > p {
      font-weight: 500;
      font-size: ${theme.fontSizes.md};
    }
  }

  .input_wrap {
    width: 6rem;
  }
`;
